import _ from 'lodash';
import services from '../../../services';
import types from './action-types';
import { getSimpleOffers } from './util';
const {
    coreAPIInstance: api,
    UserService
} = services;

const fetchOffers = (queryParams = {}) => ({
    asyncAction: () => api.offers.get(queryParams)
        .then((response) => {
            // Used in Google Tag Manager dataLayer
            const loanId = _.get(response, 'data.loanId', '');
            const underwritingCard = _.get(response, 'data.cardId', '');
            const eventId = `${Math.random().toString(36).substring(2, 15)}_${Date.now()}`;
            console.info({ loanId, underwritingCard, eventId });
            loanId && window.dataLayer.push({
                event: 'LOAN_OFFER_PRESENTED',
                loanId,
                underwritingCard,
                event_id: eventId
            });
            api.sendEvent('LOAN_OFFER_PRESENTED', eventId).catch((error) => {
                console.error('Error sending event:', error);
            });
            return response;
        })
        .catch((error) => {
            throw error;
        }),
    type: types.OFFERS_GET,
});


const fetchOffersAuthenticated = (queryParams = {}, loanId) => ({
    asyncAction: () => api.offers.getLoanOffers(queryParams, loanId)
        .then((response) => {
            const requestedAmount =  _.get(response, 'requestedAmount');
            const res = { data: getSimpleOffers(response) };
            const requestedAmountAvailable = _.get(res, 'data.requestedAmountAvailable', false);
            if (requestedAmount && requestedAmountAvailable) {
                res.data.customizedOffer = requestedAmount;
            }
            return res;
        })
        .catch((error) => {
            throw error;
        }),
    type: types.OFFERS_GET,
});


const pollWithAppRouterToken = (token=null) => ({
    asyncAction: (dispatch) => {
        dispatch({ type: types.OFFERS_GET_PENDING });
        return api.pollWithAppRouterToken(token)
            .then((response) => {
                const inquiryOffersUrl = _.get(response, 'data.inquiryOffersUrl');
                if (typeof inquiryOffersUrl === 'string' && inquiryOffersUrl.includes('?') && inquiryOffersUrl.includes('&')) {
                    window.location.href = inquiryOffersUrl;
                    const queryParams = {};
                    inquiryOffersUrl
                        .split('?')[1]
                        .split('&')
                        .forEach((queryParam) => {
                            const [key, value] = queryParam.split('=');
                            queryParams[key] = value;
                        });
                    
                    dispatch(fetchOffers(queryParams));
                }
                const user = _.get(response, 'data.user');
                user && UserService.set(user);
                return response;
            })
            .catch((error) => {
                const user = _.get(error, 'data.user');
                user && UserService.set(user);
                throw error;
            });
    },
    type: types.ROUTED_APPLICATION,
});


const pendingOffers = () => ({
    type: types.OFFERS_GET_PENDING
});

const receivedOffers = (res) => ({
    type: types.OFFERS_GET_SUCCESS,
    res,
});

const selectOfferTerm = (amount, term) => ({
    type: types.OFFERS_TERM_SELECT,
    amount,
    term,
});

const resetOfferTerm = (amount) => ({
    type: types.OFFERS_TERM_RESET,
    amount,
});

export default {
    fetchOffers,
    pendingOffers,
    pollWithAppRouterToken,
    receivedOffers,
    fetchOffersAuthenticated,
    selectOfferTerm,
    resetOfferTerm,
};
